<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Riepilogo Attività
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="salva()"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="clickChiudi"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text>
      <v-row class="mt-1">
        <v-col>
          <v-tabs v-model="tab" align-with-title grow>
            <v-tab
              :href="`#tempi`"
              active-class="py-0 my-0 indigo white--text"
              class="py-0 my-0"
            >
              TEMPI
            </v-tab>
            <v-tab
              :href="`#note`"
              active-class="py-0 my-0 indigo white--text"
              class="py-0 my-0"
            >
              NOTE
            </v-tab>
            <v-tab
              :href="`#attrezzatura`"
              active-class="py-0 my-0 indigo white--text"
              class="py-0 my-0"
            >
              ATTREZZATURA
            </v-tab>
            <v-tab
              :href="`#allegati`"
              active-class="py-0 my-0 indigo white--text"
              class="py-0 my-0"
            >
              ALLEGATI
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" align-with-title>
            <v-tab-item :value="`tempi`">
              <v-card elevation="2" outlined class="px-4 py-4">
                <v-row>
                  <v-col col="4">
                    <div class="primary--text">Inizio</div>
                    <div>{{ data_inizio }}</div>
                  </v-col>
                  <v-col col="4">
                    <div class="primary--text">Fine</div>
                    <div>{{ data_fine }}</div>
                  </v-col>
                  <v-col col="4">
                    <div class="primary--text">Durata (h)</div>
                    <div>{{ durata }}</div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <div class="primary--text">Dichiara le attività svolte</div>

                    <v-data-table
                      :headers="attivitaHeaders"
                      :items="lista_attivita"
                    >
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item :value="`note`" class="text-left">
              <v-card elevation="2" outlined class="px-4 py-4">
                <v-textarea
                  v-model="note"
                  label="Note libere attività"
                  outlined
                  hide-details
                >
                </v-textarea>
              </v-card>
            </v-tab-item>

            <v-tab-item :value="`attrezzatura`">
              <v-card elevation="2" outlined class="px-4 py-4">
                <v-row>
                  <v-col>
                    <v-toolbar color="indigo" dense>
                      <v-toolbar-title class="white--text">
                        Montata
                      </v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="clickAggiungiAttrezzaturaMontata"
                            small
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="primary">mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Aggiungi</span>
                      </v-tooltip>

                      <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-data-table
                      :headers="headers"
                      :items="attrezzaturaMontata"
                    >
                      <template v-slot:[`item.modifica`]="{ item }">
                        <v-btn small @click="clickModifica(item)">
                          <v-icon color="primary"> mdi-pencil </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-toolbar color="indigo" dense>
                      <v-toolbar-title class="white--text">
                        Smontata
                      </v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="clickAggiungiAttrezzaturaSmontata"
                            small
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="primary">mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Aggiungi</span>
                      </v-tooltip>

                      <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-data-table
                      :headers="headers"
                      :items="attrezzaturaSmontata"
                    >
                      <template v-slot:[`item.modifica`]="{ item }">
                        <v-btn small @click="clickModifica(item)">
                          <v-icon color="primary"> mdi-pencil </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item :value="`allegati`">
              <v-card elevation="2" outlined class="px-4 py-4">

              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card-text>

    <v-dialog v-model="aggiungi_attrezzatura_visible" width="600">
      <AggiungiAttrezzatura
        @click_chiudi="aggiungi_attrezzatura_visible = false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import AggiungiAttrezzatura from "./AggiungiAttrezzatura.vue";

export default {
  name: "RiepilogoAttivita",
  components: {
    AggiungiAttrezzatura,
  },
  data() {
    return {
      tab: [],
      headers: [
        {
          text: '',
          value: 'modifica',
        },
        {
          text: 'Codice',
          value: 'codice',
        },
        {
          text: 'Descrizione',
          value: 'descrizione',
        },
      ],
      attrezzaturaMontata: [],
      attrezzaturaSmontata: [],

      note: '',
      data_inizio: '12-10-21 12:00',
      data_fine: '12-10-21 14:15',
      durata: '2,25',

      attivitaHeaders: [
        {
          text: 'Attività',
          value: 'attivita',
        },
        {
          text: 'Durata (minuti)',
          value: 'durata',
        },
        {
          text: 'Note',
          value: 'note',
        },
      ],
      lista_attivita: [
        {
          attivita: 'Att 1',
          durata: '15',
          note: 'note',
        },
        {
          attivita: 'Att 2',
          durata: '45',
          note: 'note',
        },
        {
          attivita: 'Att 3',
          durata: '30',
          note: 'note',
        },
        {
          attivita: 'Att 4',
          durata: '0',
          note: 'note',
        },
        {
          attivita: 'Att 5',
          durata: '45',
          note: 'note',
        },
      ],

      aggiungi_attrezzatura_visible: false,
    };
  },
  methods: {
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickAggiungiAttrezzaturaMontata() {
      this.aggiungi_attrezzatura_visible = true;
    },
    clickAggiungiAttrezzaturaSmontata() {
      this.aggiungi_attrezzatura_visible = true;
    },
    clickModifica() {

    },
    salva() {
      this.$emit("click_salva");
    },
  },
};
</script>
